import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';
import { DrawerOpenEvent } from '@theme/theme-drawer';

// Calmera UAE — Bundle & Delivery Progress Bar
function calmeraUpdateProgress() {
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var qty = cart.item_count;
      var total = cart.total_price / 100;
      var threshold = 200;
      var bundleEl = document.getElementById('calmera-bundle-msg');
      var deliveryEl = document.getElementById('calmera-delivery-msg');
      var barEl = document.getElementById('calmera-bar-fill');
      if (!bundleEl || !deliveryEl || !barEl) return;
      if (qty <= 0) {
        bundleEl.textContent = '';
      } else if (qty === 1) {
        bundleEl.textContent = 'Add 1 more item to unlock AED 9 bundle savings.';
      } else if (qty % 2 === 0) {
        bundleEl.textContent = 'Your AED ' + (Math.floor(qty / 2) * 9) + ' bundle saving has been applied. \u2713';
      } else {
        bundleEl.textContent = 'Add 1 more item to save an extra AED 9.';
      }
      if (total >= threshold) {
        deliveryEl.textContent = "You\u2019ve unlocked Free UAE Delivery \uD83D\uDE9A \u2713";
        barEl.style.width = '100%';
      } else {
        deliveryEl.textContent = 'Add AED ' + Math.ceil(threshold - total) + ' more to unlock Free UAE Delivery \uD83D\uDE9A';
        barEl.style.width = Math.min((total / threshold) * 100, 100) + '%';
      }
    });
}

class CartDrawerComponent extends Component {
  #summaryThreshold = 0.5;

  get #themeDrawer() {
    return (this.closest('theme-drawer'));
  }

  get #dialog() {
    return this.closest('dialog');
  }

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(StandardEvents.cartLinesUpdate, this.#handleCartLinesUpdate);
    this.#themeDrawer?.addEventListener(DrawerOpenEvent.eventName, this.#handleDrawerOpen);

    if (this.#themeDrawer?.hasAttribute('open')) {
      this.#handleDrawerOpen();
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(StandardEvents.cartLinesUpdate, this.#handleCartLinesUpdate);
    this.#themeDrawer?.removeEventListener(DrawerOpenEvent.eventName, this.#handleDrawerOpen);
  }

  #handleDrawerOpen = () => {
    this.#updateStickyState();
    // Update Calmera progress bar when drawer opens
    setTimeout(calmeraUpdateProgress, 300);

    customElements.whenDefined('shopify-payment-terms').then(() => {
      const cta = this.querySelector('shopify-payment-terms')?.shadowRoot?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', () => this.#themeDrawer?.close(), { once: true });
    });
  };

  #handleCartLinesUpdate = (event) => {
    const shouldAutoOpen = this.hasAttribute('auto-open') && event.action === 'add' && !this.#themeDrawer?.isOpen;

    const sourceModal = (
      event.target instanceof Element ? event.target.closest('dialog:modal') : null
    );

    if (shouldAutoOpen && !sourceModal && !this.#isCartEmpty()) {
      this.#themeDrawer?.open();
    }

    event.promise
      ?.then(({ detail }) => {
        const settle = () => requestAnimationFrame(() => this.#updateStickyState());

        if (!shouldAutoOpen || detail?.didError) {
          settle();
          // Update Calmera progress bar after cart update settles
          setTimeout(calmeraUpdateProgress, 300);
          return;
        }

        const openAndSettle = () => {
          if (!this.#themeDrawer?.isOpen) this.#themeDrawer?.open();
          settle();
          // Update Calmera progress bar after cart opens and settles
          setTimeout(calmeraUpdateProgress, 500);
        };

        if (sourceModal?.open) {
          sourceModal.addEventListener('close', openAndSettle, { once: true });
        } else {
          openAndSettle();
        }
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[cart-drawer] Event promise rejected:', error);
      });
  };

  #isCartEmpty() {
    return Boolean(this.querySelector('.cart-drawer--empty'));
  }

  #updateStickyState() {
    const dialog = this.#dialog;
    if (!dialog) return;

    const content = dialog.querySelector('.cart-drawer__content');
    const summary = dialog.querySelector('.cart-drawer__summary');

    if (!content || !summary) {
      dialog.setAttribute('cart-summary-sticky', 'false');
      return;
    }

    const drawerHeight = dialog.getBoundingClientRect().height;
    const summaryHeight = summary.getBoundingClientRect().height;
    const ratio = summaryHeight / drawerHeight;
    dialog.setAttribute('cart-summary-sticky', ratio > this.#summaryThreshold ? 'false' : 'true');
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}